import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import { SIMPLE_SELECT_PROPS } from './types';

const defaultComponents = {};

const SimpleSelect = forwardRef(
  (
    {
      size = SIZES.small,
      id = null,
      name = null,
      placeholder = '',
      options,
      value = null,
      defaultValue = null,
      disabled = false,
      invalid = false,
      preventOverflow = false,
      onChange = Function.prototype,
      onBlur = Function.prototype,
      onFocus = Function.prototype,
      maxMenuHeight = null,
      components = defaultComponents,
      transparent = false,
    },
    ref
  ) => (
    <BaseSelect
      ref={ref}
      appearance={APPEARANCES.default}
      size={size}
      inputId={id}
      name={name}
      placeholder={placeholder}
      options={options}
      value={value}
      defaultValue={defaultValue}
      clearable={false}
      disabled={disabled}
      invalid={invalid}
      preventOverflow={preventOverflow}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      components={components}
      maxMenuHeight={maxMenuHeight}
      transparent={transparent}
    />
  )
);

SimpleSelect.displayName = 'SimpleSelect';
SimpleSelect.propTypes = SIMPLE_SELECT_PROPS;

export default SimpleSelect;
